import { DashboardOverview } from '@adminModels';
import { EventStatsDto, RoleUserStatsDto, VolunteerStatsDto } from '@klubovna/api-client';

export interface DashboardState {
  overview: DashboardOverview | null;
  loading: boolean;
  error: string | null;
  userStats: RoleUserStatsDto[];
  userStatsLoading: boolean;
  userStatsError: string | null;
  eventStats: EventStatsDto | null;
  eventStatsLoading: boolean;
  eventStatsError: string | null;
  volunteerStats: VolunteerStatsDto | null;
  volunteerStatsLoading: boolean;
  volunteerStatsError: string | null;
}

export const initialDashboardState: DashboardState = {
  overview: null,
  loading: false,
  error: null,
  userStats: [],
  userStatsLoading: false,
  userStatsError: null,
  eventStats: null,
  eventStatsLoading: false,
  eventStatsError: null,
  volunteerStats: null,
  volunteerStatsLoading: false,
  volunteerStatsError: null,
};
